/* eslint-disable functional/immutable-data */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import {
  getLoggedInToken,
  isUserLoggedIn,
  parseCookie,
} from "../../payment/miscellaneous/parseCookie";
import { setToken } from "../../sign-in/miscellaneous/setToken";
import { fetchItCatch } from "./fetchItCatch";
import { fetchItThen } from "./fetchItThen";

export type FetchItOutput =
  | (
    | { readonly tag: "informational" }
    | { readonly tag: "successful" }
    | { readonly tag: "redirection" }
    | { readonly tag: "client-error" }
    | { readonly tag: "data-error" }
    | { readonly tag: "server-error" }
  ) & { readonly response: Response };

type FetchParameters = Parameters<typeof fetch>;

export type FetchItTag = "authorization" | "none";

export const fetchIt = async (
  tag: "authorization" | "none",
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  ...input: FetchParameters
): Promise<FetchItOutput> => {
  await setToken("on-fetch");

  // Get token cookie and a login status.
  const loggedInToken = getLoggedInToken();
  const loggedIn = isUserLoggedIn(document.cookie);

  // NOT exists token and loggedIn is true return for out of function.
  if (!loggedInToken && !!loggedIn) {
    return undefined as any;
  }

  const cookieParsed = parseCookie(document.cookie);
  const clientId: string = cookieParsed.MkHcClientId ?? "";

  const headersInput = input[1]?.headers;
  const headersWithAuthorization = new Headers(headersInput);
  headersWithAuthorization.append(
    "Authorization",
    `Bearer HIGHLY_UNIQUE_BEARER_TOKEN`
  );
  headersWithAuthorization.append("X-DIGIKEY-Client-Id", clientId);

  headersWithAuthorization.append("Partner-Domain", window.location.hostname);

  const inputWithAuthorization: FetchParameters = [
    input[0],
    {
      ...input[1],
      headers:
        tag === "authorization" ? headersWithAuthorization : headersInput,
    },
  ];

  return fetch(...inputWithAuthorization)
    .then(fetchItThen)
    .catch(fetchItCatch);
};
